const projectConstant = {
  selectedProjectId: 'selectedProjectId',
  tooltipArea: {
    domain: 'Domain',
    attribute: 'Attribute',
  },
};

export default projectConstant;
